import { LuGlobe } from '@react-icons/all-files/lu/LuGlobe'
import React from 'react'

import { Button, Text } from 'components/ds'
import { SourceFilterMenu } from 'components/search/search-columns/source-column/source-filter-menu'

/**
 * Source filter beside "+ Filter": opens the same menu as the Source column
 * header, styled like a filter badge, with the number of checked sources.
 */
const SourceFilterButton = (): React.ReactNode => (
  <SourceFilterMenu
    renderTrigger={({ isFiltered, count }) => (
      // Same look as an active / inactive filter badge.
      <Button
        variant={isFiltered ? 'soft' : 'surface'}
        color={isFiltered ? undefined : 'gray'}
        highContrast={isFiltered}
        aria-label={`Source filter, ${count} selected`}
      >
        <LuGlobe />
        <Text as="span" size={{ initial: '1', sm: '2' }}>
          {`Source ${count}`}
        </Text>
      </Button>
    )}
  />
)

export default SourceFilterButton
